import { Injectable } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import * as animalGroupActions from '../store/animal-group.actions';

@Injectable({
  providedIn: 'root',
})
export class AnimalGroupGuard {
  constructor(private readonly store: Store<RootState>) {}

  canActivate(): Observable<boolean> {
    this.store.dispatch(animalGroupActions.loadData());
    return of(true);
  }
}
